import { render, staticRenderFns } from "./simBindingRecord.vue?vue&type=template&id=5715652b"
import script from "./simBindingRecord.vue?vue&type=script&lang=js"
export * from "./simBindingRecord.vue?vue&type=script&lang=js"
import style0 from "./simBindingRecord.vue?vue&type=style&index=0&id=5715652b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports